import { useMemo } from 'react';

import { useFrontendConfiguration } from '@rover/rsdk/src/modules/Data/Core/FrontendConfiguration';

import { RoverStatsigUser } from '../types';
import { mapExperimentUserAttributesToRoverStatsigUser } from '../utils';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useRoverStatsigUser(initialUserAttributes?: Record<string, any>): {
  roverStatsigUser: RoverStatsigUser;
  isLoading: boolean;
  error: Error | null;
} {
  const {
    settings: frontendConfigSettings,
    isLoading,
    error,
  } = useFrontendConfiguration({
    enabled: !initialUserAttributes,
  });
  const apiUserAttributes = frontendConfigSettings?.experimentUserAttributes;

  // Prefer initial attributes (from server context) over API attributes
  const experimentUserAttributes = initialUserAttributes ?? apiUserAttributes;

  const roverStatsigUser: RoverStatsigUser = useMemo(
    () => mapExperimentUserAttributesToRoverStatsigUser(experimentUserAttributes),
    [experimentUserAttributes]
  );

  // If we have initial attributes, don't show loading state
  const effectiveLoading = initialUserAttributes ? false : isLoading;

  return { roverStatsigUser, isLoading: effectiveLoading, error };
}
